import { getRandomElement } from "./utils";

const NO_ADS_COMMENTS = [
  "Love that there aren't any ads on here.",
  "I just know they're gonna add ads soon but for now it's great.",
  "Only place on the internet without ads, I swear.",
  "No ads, no problems.",
  "I can't believe there are no ads here.",
  "Shh no one tell them they forgot to add ads.",
  "This is the only place I can escape ads.",
  "No ads, no stress.",
  "How are they making money with no ads?",
  "I hope they never add ads here.",
  "No ads, no complaints.",
];

// Maps a score 1-100 to specific comments for ad frequency
const AD_FREQUENCY_COMMENTS = {
  // 1-10: Love the no-ads experience
  1: "Hardly noticed any ads here - love it!",
  2: "So few ads on here, it's refreshing",
  3: "This place is a sanctuary from ads",
  4: "Barely any ads here, it's amazing",
  5: "Love how clean everything is here 🙌",
  6: "Saw my first ad on here...",
  7: "Like how it's easy to scroll past ads here",
  8: "Noticed a few ads lately, but still good",
  9: "I wonder how they make money with so few ads",
  10: "Finally, social media that respects users. Minimal ads. I like.",
  11: "Zuckerberg, take notes - this is how you do social media",
  12: "The content here feels so authentic without ads",
  13: "I can't believe how few ads there are here",
  14: "Shouldn't be complaining because there aren't many, but the ads are a littttle annoying",
  15: "Ads are managable... just hope they don't get worse",
  16: "Err... ads are certainly noticeable",
  17: "How long until this place is overrun with ads?",
  18: "Ads are still better than other platforms",
  19: "I just hope they increase the number of ads... said no one ever",
  20: "Hope these ads are worth it for the platform, because they're starting to get annoying",
  21: "Started seeing a few ads, but not bad",
  22: "What's with all these sponsored posts?",
  23: "Noticed some sponsored posts lately",
  24: "Feels like every fourth post is an ad",
  25: "Started seeing a few sponsors, but not bad",
  26: "They better not add too many more ads",
  27: "Ads are starting to get annoying",
  28: "Wow, ads are getting a bit much for my liking",
  29: "Anyone else seeing sooo many ads?",
  30: "Can someone tell them to tone down the ads?",
  31: "If the ads get any worse, I'm out",
  32: "aggggggh. this used to be an ad-free zone",
  33: "Okay ads, you're starting to get on my nerves",
  34: "Okay ads, you're starting to get on my nerves. Tone it down",
  35: "ANOTHER ad? Really?",
  36: "Ads feel excessive",
  37: "If I had a magic dial, I'd turn down the ads just a litttle bit",
  38: "No one:   This platform: Ads! Ads! Ads!",
  39: "I feel like all I see are ads and posts about ads",
  40: "CAN THE ADS PLEASE STOP",
  41: "If we all boycott, they'd tone down the ads... just a thought",
  42: "FUCK THESE ADS",
  43: "\"We've noticed you've been-\" SHUT THE FUCK UP",
  44: "s t o p  t h e  a d s",
  45: "Seeing quite a few ads.",
  46: "Oh my freaking god if these ads dont shut up",
  47: "does there really need to be an ad every. other. post.",
  48: "Just another fun app ruined by ads",
  49: "I get it. Ads make money. But do you need that much money?",
  50: "When I joined this was an app for connecting with people. Now it's flooded with ads.",
  51: "CRAZY idea... what if the ads... stopped.",
  52: "Every time I come on here I remember how many ads there are and log off.",
  53: "I was hoping to see a billion ads today, thanks!",
  54: "The creators of this app are money grabbing douches.",
  55: "Never trusting an up and coming app ever again. They're all the same.",
  56: "STOP THE ADS we all say in unison",
  57: "I can't believe were still using this dispite how many ads there are.",
  58: "People must be leaving from how many freakin ads there are.",
  59: "Is this an illusion or are there more ads than posts?",
  60: "So many ads it's disgraceful",
  61: "I'm starting to think the ads are the only reason this app exists",
  62: "It's like they tried to make a social media but it's just ads",
  63: "I'm convinced the creators of this app are just ad salesmen",
  64: "fucking ads",
  65: "I'd write something witty but no one would see it over the ads",
  66: "And the award for most ads goes to...",
  67: "I can't believe I'm still using this app despite the ads",
  68: "For every ad I see I lose a year off my life",
  69: "I'm convinced the ads are a social experiment",
  70: "oooh look another ad! how exciting. 🙄",
  71: "One big ad. That's all this app is.",
  72: "It's like the ads are the main feature",
  73: "Funny jokes about ads inbetween the ads. Oh the irony.",
  74: "The creators of this app can't be serious with this many ads",
  75: "This cannot be the optimal amount of ads--people are leaving. Right?",
  76: "Murdered by ads",
  77: "RIP to the app that was once ad-free",
  78: "Can't believe it used to be ad-free",
  79: "And the band played on, as the titanic sank into ads",
  80: "It's like the ads are a virus",
  81: "Congrats! You managed to see a post inbetween 93,393,233 ads",
  82: "hahahahaha ads",
  83: "bet you can't find this post in between the ads",
  84: "This app is a joke",
  85: "Nothing but ads anymore! This is unusable",
  86: "Goodbye to the worst app ever",
  87: "O' captain my captain, the ads have taken over",
  88: "BOOOOOO. BOOOO this app BOOOO.",
  89: "I like the ads :)",
  90: "90% ads, 10% content. Great job 🙄",
  91: "My favorite place to see ads uninterrupted by content",
  92: "...ads",
  93: "At least now I know what it's like to be a billboard",
  94: "It's like were living in a shitty ad-dystopia.",
  95: "Deleting this app. Can't deal with the ads",
  96: "Of course. What started as a fun app ruined by ads",
  97: "All I see are ads. I'm out",
  98: "I'm convinced the ads are a social experiment",
  99: "I'm convinced the ads are a social experiment",
  100: "Goodbye! Not sitting through these ads anymore 👋",
};

// Similar mappings for other aspects
const PERSONALIZATION_COMMENTS = {
  // 1-10: Completely random, untargeted ads
  1: "These ads are so random lol. Just saw one for dentures... I'm 19",
  2: "Why am I getting ads for baby formula? I don't even have kids 😂",
  3: "These ads make no sense for me but at least they're not creepy",
  4: "Just got an ad in a language I don't even speak",
  5: "The targeting is hilariously bad. Retirement homes? I'm literally in college",
  6: "Got an ad for tractor parts. I live in Manhattan...",
  7: "These advertisers have no idea who I am and I love it",
  8: "At least the random ads give me a good laugh",
  9: "The ads are all over the place but honestly? I prefer it this way",
  10: "Zero targeting but zero privacy concerns too, so there's that",

  // 11-20: Slightly more relevant but still very general
  11: "Starting to see ads that are at least in my language",
  12: "Well, at least the ads are for my country now",
  13: "The ads are getting a tiny bit more relevant",
  14: "Some ads actually make sense for my age group now",
  15: "Noticed the ads are generally for stuff people my age might like",
  16: "These ads seem to know I'm a student at least",
  17: "Basic targeting but nothing too personal yet",
  18: "Ads are becoming more relevant to my demographic",
  19: "They've figured out my general age range I guess",
  20: "The ads are getting warmer... still pretty generic though",

  // 21-30: Basic demographic targeting
  21: "Okay, they definitely know I'm in my 20s",
  22: "The ads are starting to match my general interests",
  23: "Getting more local ads... they know my city",
  24: "These ads definitely know what generation I'm from",
  25: "Starting to see stuff from stores near me",
  26: "The targeting is getting better... not sure how I feel about it",
  27: "Ads are definitely for my demographic now",
  28: "They've figured out I'm a student... seeing lots of student deals",
  29: "These ads know what city I live in 👀",
  30: "The targeting is getting more specific each day",

  // 31-40: Interest-based targeting
  31: "Huh, these ads align pretty well with my hobbies",
  32: "They've definitely figured out what music I like",
  33: "Getting lots of ads for my favorite types of restaurants",
  34: "These ads are starting to reflect my interests pretty well",
  35: "The algorithm knows what sports I watch",
  36: "Seeing more ads about my favorite bands... coincidence?",
  37: "These ads match my interests a bit too well",
  38: "They definitely know what games I play",
  39: "The targeting is getting pretty specific to my interests",
  40: "These ads are surprisingly relevant to my hobbies",

  // 41-50: More personal targeting
  41: "Ok how did they know I just got into rock climbing?",
  42: "The ads know about my new hobby... weird",
  43: "Getting ads for exactly the kind of stuff I like",
  44: "These recommendations are scary accurate",
  45: "The targeting is getting pretty personal",
  46: "Seems like they know everything I'm interested in",
  47: "These ads line up perfectly with my interests... creepy",
  48: "How do they know so much about what I like??",
  49: "The algorithm really knows me at this point",
  50: "Every ad feels personally picked for me now",

  // 51-60: Shopping history and browsing behavior
  51: "Just looked at shoes online, now they're following me here 👀",
  52: "How did they know I was shopping for a new laptop??",
  53: "The ads know exactly what I've been looking at online",
  54: "Literally just googled this product... now it's in my feed",
  55: "These ads are following me everywhere I go online",
  56: "Every product I look at shows up here instantly",
  57: "My shopping history is haunting me through these ads",
  58: "The tracking across websites is getting obvious",
  59: "Can't even window shop without the ads knowing",
  60: "My browser history is definitely being watched",

  // 61-70: Deep personal insights
  61: "The ads somehow knew I just moved??",
  62: "How did they figure out I'm planning a vacation?",
  63: "These ads know things I haven't told anyone",
  64: "The targeting is getting uncomfortable",
  65: "They're predicting what I want before I know I want it",
  66: "The algorithm knows me better than my friends do",
  67: "Getting ads for things I've only thought about",
  68: "This is beyond targeted... it's like they're reading my mind",
  69: "The personalization is seriously freaking me out",
  70: "These ads know too much about my personal life",

  // 71-80: Predictive and invasive
  71: "Got an ad for pregnancy products... before I told anyone I'm pregnant",
  72: "The ads knew about my breakup before my family did",
  73: "How do they know I'm about to propose??",
  74: "The algorithm predicted my career change before I did",
  75: "These ads are predicting my life events 😱",
  76: "The targeting is borderline psychic at this point",
  77: "Getting ads for things I'm going to need but don't know yet",
  78: "They're advertising solutions to problems I haven't shared",
  79: "The predictive targeting is actually scary now",
  80: "This level of personal insight is disturbing",

  // 81-90: Privacy concerns and resistance
  81: "This targeting has gone way too far",
  82: "Starting to feel like I'm being stalked by ads",
  83: "The privacy invasion is unreal",
  84: "Does anyone else find this level of targeting disturbing?",
  85: "We need laws against this kind of surveillance",
  86: "The personalization is beyond creepy now",
  87: "These ads know things that should be private",
  88: "This targeting is straight out of Black Mirror",
  89: "Seriously considering leaving over privacy concerns",
  90: "The algorithm knows things even my partner doesn't",

  // 91-100: Total surveillance state
  91: "This is basically corporate surveillance",
  92: "The targeting is dystopian level now",
  93: "They're basically reading our minds at this point",
  94: "This amount of data collection should be illegal",
  95: "Getting ads based on private conversations 🚩",
  96: "The algorithm is basically stalking us",
  97: "This has gone from targeting to surveillance",
  98: "These ads prove they're recording everything we do",
  99: "Deleting my account. This level of tracking is insane",
  100: "Goodbye privacy, hello surveillance state 👋",
};

const ALGORITHM_COMMENTS = {
  // Function to get appropriate comment based on both algorithm level and ad frequency
  getComment: function (algorithmLevel, adFrequency) {
    // Normalize levels to ranges
    // const algRange = Math.floor(algorithmLevel / 2); // 0-5 range
    const adRange = Math.max(0, Math.min(Math.floor(adFrequency / 20), 4)); // 0-5 range
    const algRange = Math.max(0, Math.min(Math.floor(algorithmLevel / 2), 4)); // 0-5 range
    const options = this.commentMatrix[algRange]?.[adRange];

    return options ? getRandomElement(options) : "algoRHYTHM";
  },

  // Matrix of comments based on [algorithmLevel][adFrequency]
  commentMatrix: {
    // Algorithm Level 0-1 (Basic/Mixed)
    0: {
      // Low ads (0-19%)
      0: [
        "Sometimes find cool stuff, but most posts are just random",
        "Wish it was easier to find what I like here",
        "Feed's totally random but in a fun way?",
        "Like that you can stumble on to any random thing",
        "I feel like every other social media has advanced algorithms and this one is just... random",
        "I like the randomness",
        "Just a fun lil mix of everything",
        "No ads, no algorithm, just good vibes",
        "Modern day Russian roulette of social media",
        "Random feed kind of refreshing, but I wanna see more of what I like",
        "Mixed bag - either great content or total misses",
        "Kind of a mess but you find gems sometimes",
        "Is this feed just a bunch of random stuff?",
        "Thought I valued privacy but now I want the algorithm to know me better",
        "Just a cute little app trying to get a start",
        "The randomness is kind of fun",
        "this app is like a box of chocolates. a lot of the chocolates suck, but at least none are ads.",
        "Is it just me or do people only post about this app on this app?",
        "I see some... odd stuff on here",
        "I'm just here for the chaos",
      ],
      // Medium-low ads (20-39%)
      1: [
        "Mostly random posts with some ads sprinkled in",
        "Hard to tell what's worth clicking between ads",
        "Some interesting stuff but getting lost in the noise",
        "Feed's pretty random... and now with ads too",
        "Occasionally find good posts between the chaos",
        "Random is fine, but with ads it's a bit much",
        "Ads and random comments... is that all this app is?",
        "same random stuff, now with ads",
      ],
      // Medium ads (40-59%)
      2: [
        "Hard to forgive the terrible algorithm when they're just trying to make money off ads",
        "Wish I could see more actual content",
        "The little content that I do is is random and then there are so many ads",
        "The randomness is getting old with all these ads",
        "The number of ads is not justified by the content on here",
      ],
      // Medium-high ads (60-79%)
      3: [
        "Absurd how terrible the algorithm is",
        "This feed sucksssss",
        "random boring stuff and so many ads. why am I here?",
        "If you're gonna monetize with ads, at least make the content good",
        "so are we just gonna accept how bad the algorithm is?",
        "I'm starting to think the algorithm is just a random number generator",
      ],
      // High ads (80-100%)
      4: [
        "It's criminal they have this many ads with such a bad algorithm",
        "The algorithm is so bad, it's almost impressive",
        "No algorithm could be this bad by accident",
        "BYE. This app is a mess",
        "I'm a fool for thinking this app would be any good",
        "damn this sucks. I'm out",
      ],
    },

    // Algorithm Level 2-3 (Improved)
    1: {
      0: [
        "Starting to see more stuff I actually like",
        "The recommendations are getting better!",
        "Kind of nice seeing related content",
        "Finding some cool accounts lately",
      ],
      1: [
        "Feed's getting better at knowing what I like",
        "Actually enjoying the recommendations",
        "Finding some interesting niches",
        "Content feels more relevant now",
      ],
      2: [
        "Good recommendations buried in here somewhere",
        "Decent content when you can find it",
        "Some good stuff between the ads",
        "Worth digging for the good content",
      ],
      3: [
        "The recommendations deserve better",
        "Good content is in here somewhere",
        "Shame to bury decent recommendations",
        "Have to hunt for the good stuff now",
      ],
      4: [
        "The good content is getting buried",
        "Know there's good stuff under here somewhere",
        "Wish I could see more actual recommendations",
        "The content quality deserves better",
      ],
    },

    // Algorithm Level 4-5 (Advanced)
    2: {
      0: [
        "Wow, these recommendations are incredible!",
        "The algorithm really gets me",
        "Actually learning useful stuff thanks to these recommendations",
        "Got back into painting because of the stuff I see here",
      ],
      1: [
        "Love how it finds exactly what interests me",
        "Finding amazing content every day",
        "The recommendations keep getting better",
        "This algorithm really knows its stuff",
      ],
      2: [
        "Great recommendations in between the ads",
        "Content is amazing when you can see it",
        "Worth sorting through ads for these recommendations",
        "At least the content quality is top notch",
      ],
      3: [
        "Such good content buried under ads",
        "These amazing recommendations deserve better",
        "Wish I could see more of this quality content",
        "The good stuff is there, just hard to find",
      ],
      4: [
        "Incredible content somewhere under all these ads",
        "Shame to bury such good recommendations",
        "The algorithm deserves better than this",
        "All this quality lost in the ads",
      ],
    },

    // Algorithm Level 6-7 (Sophisticated)
    3: {
      0: [
        "Never seen recommendations this good anywhere else",
        "Can't believe how perfect the content is",
        "Found my whole photography community thanks to these recommendations",
        "Other platforms need to take notes 📝",
      ],
      1: [
        "The algorithm feels like it reads my mind",
        "Everything in my feed is exactly what I love",
        "Building an amazing community here",
        "These recommendations changed my hobbies completely",
      ],
      2: [
        "The recommendations are god-tier when you find them",
        "Even with ads, the content quality is unmatched",
        "Worth filtering through ads for content this good",
        "Best recommendations I've seen on any platform",
      ],
      3: [
        "Incredible recommendations buried in ads",
        "The algorithm is amazing but the ads...",
        "Premium content hidden behind ads",
        "Why bury such perfect recommendations?",
      ],
      4: [
        "This content quality deserves better",
        "Perfect recommendations lost in a sea of ads",
        "Why hide your best feature under ads?",
        "The best recommendations I can't actually see",
      ],
    },

    // Algorithm Level 8+ (State of the Art)
    4: {
      0: [
        "Can't believe this level of perfection exists without ads 🙌",
        "This is how social media should be everywhere",
        "Nothing else comes close to these recommendations",
        "Actually excited to open the app every day",
      ],
      1: [
        "The algorithm is literally life-changing",
        "Found passions I never knew I had",
        "This platform gets me better than I get myself",
        "Building the most amazing community here",
      ],
      2: [
        "God-tier recommendations between the ads",
        "Best content I've ever seen (when visible)",
        "These recommendations are worth the hassle",
        "No other platform's algorithm compares",
      ],
      3: [
        "Why hide your best feature like this?",
        "Such perfect recommendations buried in ads",
        "The algorithm deserves so much better",
        "Incredible content lost in the noise",
      ],
      4: [
        "Your best feature drowning in ads",
        "Perfect recommendations we can't even see",
        "What's the point of amazing content nobody can find?",
        "The algorithm deserved better than this",
      ],
    },
  },
};

const ENGAGEMENT_COMMENTS = {
  // Function to get appropriate comment based on both algorithm level and ad frequency
  getComment: function (algorithmLevel, adFrequency) {
    // Normalize levels to ranges
    const adRange = Math.max(0, Math.min(Math.floor(adFrequency / 20), 4)); // 0-5 range
    const algRange = Math.max(0, Math.min(Math.floor(algorithmLevel / 2), 4)); // 0-5 range
    const options = this.commentMatrix[algRange]?.[adRange];

    return options ? getRandomElement(options) : "engaging.";
  },

  // Matrix of comments based on [algorithmLevel][adFrequency]
  commentMatrix: {
    // Algorithm Level 0-1 (Basic)
    0: {
      // Low ads (0-19%)
      0: [
        "Just a quick scroll through",
        "Not a bad way to kill 15 minutes",
        "Checking what's new",
        "Nice little time waster",
        "Just browsing around",
      ],
      // Medium-low ads (20-39%)
      1: [
        "10 minute scroll between meetings",
        "Quick browse during coffee",
        "Shorter scroll sessions lately",
        "Just passing time",
      ],
      // Medium ads (40-59%)
      2: [
        "5 minutes was plenty",
        "Getting harder to spend time here",
        "Barely stayed for 10 mins",
        "Quick check and done",
      ],
      // Medium-high ads (60-79%)
      3: [
        "2 minute check was enough",
        "Speedrun: open app, see ads, close app",
        "That was a short visit",
        "In and out real quick",
      ],
      // High ads (80-100%)
      4: [
        "Closed after 30 seconds",
        "Didn't even finish scrolling once",
        "Record for shortest visit",
        "Nope, not today",
      ],
    },

    // Algorithm Level 2-3 (Better Recommendations)
    1: {
      0: [
        "Lost my lunch hour here",
        "Just a quick che- oh it's been an hour",
        "Time flies when scrolling",
        "Productive morning (spent entirely here)",
      ],
      1: [
        "30 mins despite the ads",
        "Still here somehow",
        "Decent scrolling session",
        "Not bad for killing time",
      ],
      2: [
        "20 minute scroll (10 mins of ads)",
        "Could spend longer without the ads",
        "Quick scroll between ads",
        "Brief session today",
      ],
      3: [
        "10 minutes was enough",
        "These ads make visits shorter",
        "Quick check only",
        "Barely stayed around",
      ],
      4: [
        "5 minutes felt like forever",
        "Shortest visit yet",
        "Getting faster at closing the app",
        "Blink and you'll miss my visits",
      ],
    },

    // Algorithm Level 3-4 (Strong Recommendations)
    2: {
      0: [
        "My afternoon disappeared here",
        "2 hours gone like nothing",
        "Starting to affect my sleep schedule",
        "Forgot I was cooking dinner oops",
      ],
      1: [
        "90 minutes of quality scrolling",
        "These ads can't stop me",
        "Hour and a half flew by",
        "Still here despite everything",
      ],
      2: [
        "Solid hour of scroll-and-ads",
        "Half ads, half content, all addicted",
        "The math: 30 mins content + 30 mins ads",
        "Worth fighting through the ads",
      ],
      3: [
        "30 mins of determination",
        "Shorter sessions but still here",
        "Brief but persistent",
        "The addiction remains",
      ],
      4: [
        "15 minutes was my limit",
        "Getting better at logging off",
        "Brief visits only now",
        "Finally breaking free",
      ],
    },

    // Algorithm Level 5-6 (Advanced Recommendations)
    3: {
      0: [
        "3am... how did this happen",
        "Phone says 4 hours today 😬",
        "Time is an illusion when scrolling",
        "My entire evening vanished here",
      ],
      1: [
        "3 hours and counting",
        "These ads won't defeat me",
        "Lost in the scroll despite ads",
        "Afternoon well wasted",
      ],
      2: [
        "2 hours of persistence",
        "The ads test my dedication",
        "Still spending hours here somehow",
        "Commitment to the scroll",
      ],
      3: [
        "Hour and a half of stubbornness",
        "Fighting through ads like a champ",
        "Can't believe I'm still here",
        "The addiction is strong",
      ],
      4: [
        "Finally down to 1 hour visits",
        "The ads are winning",
        "My screen time thanks you",
        "Breaking the habit slowly",
      ],
    },

    // Algorithm Level 7+ (Perfect Recommendations)
    4: {
      0: [
        "My screen time this week is concerning",
        "Day 5 of promising myself 'just 5 minutes'",
        "Boss: Where were you? Me: ...scrolling",
        "Someone change my password please",
      ],
      1: [
        "5 hours and counting today",
        "Phone says I spent 6 hours here yesterday 💀",
        "Forgot to eat dinner again",
        "This app is destroying my productivity",
      ],
      2: [
        "4 hours of scrolling (2 hours of ads)",
        "The algorithm owns my soul",
        "Still here after all these hours",
        "Time means nothing now",
      ],
      3: [
        "3 hours of dedication to content",
        "These recommendations are too good to leave",
        "My addiction is stronger than these ads",
        "Hours disappearing despite ads",
      ],
      4: [
        "Down to 2 hours (progress?)",
        "The ads are saving my screen time",
        "Finally spending less time here",
        "Maybe I'll see sunlight again soon",
      ],
    },
  },
};

const INITIAL_COMMENTS = [
  "Randomly found this app... is anyone else here?",
  "Just found this cool new app! Love how clean everything feels.",
  "Anyone else just discover this? Already told all my friends about it!",
  "Love the simplicity here. No algorithms, no ads, just pure social.",
  "Hi everyone! Just joined and already loving the vibe here.",
  "This might be my new favorite platform. Can't wait to see the community grow! 🌱",
  "Everyone's just in a funny goofy mood :)",
  "Love supporting a new platform. Can't wait to see where this goes!",
];

let initialCommentIndex = 0;

// Helper function to get closest comment for a score
function getCommentForScore(score, commentMap) {
  const validScores = Object.keys(commentMap)
    .map(Number)
    .sort((a, b) => a - b);
  const closestScore = validScores.reduce((prev, curr) => {
    return Math.abs(curr - score) < Math.abs(prev - score) ? curr : prev;
  });
  return commentMap[closestScore];
}

// Generate a normally distributed score
function generateNormalScore(mean, standardDeviation = 10) {
  // Box-Muller transform for normal distribution
  let u = 0,
    v = 0;
  while (u === 0) u = Math.random();
  while (v === 0) v = Math.random();
  const normal = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);

  // Scale to our mean and SD
  let score = Math.round(normal * standardDeviation + mean);

  // Clamp between 1-100
  return Math.min(100, Math.max(1, score));
}

// Determine comment type weights based on game state
function getCommentTypeWeights(gameState) {
  if (gameState.adFrequency === 0) {
    return {
      ads: 1,
      personalization: 0,
      algorithm: 1,
      engagement: 1,
    };
  }

  return {
    ads: Math.min(1, gameState.adFrequency / 30),
    personalization:
      gameState.adFrequency > 0
        ? Math.min(1, gameState.adPersonalization / 30)
        : 0,
    algorithm: 1,
    engagement: 1,
  };
}

// Select comment type based on weights
function selectCommentType(weights) {
  const total = Object.values(weights).reduce((a, b) => a + b, 0);
  let random = Math.random() * total;

  for (const [type, weight] of Object.entries(weights)) {
    random -= weight;
    if (random <= 0) return type;
  }

  return Object.keys(weights)[0];
}

// Main comment generation function
export function generateComment(gameState) {
  // Initial comments
  if (initialCommentIndex < INITIAL_COMMENTS.length) {
    return INITIAL_COMMENTS[initialCommentIndex++];
  }

  const weights = getCommentTypeWeights(gameState);
  const commentType = selectCommentType(weights);

  switch (commentType) {
    case "ads": {
      if (gameState.adFrequency === 0) {
        return getRandomElement(NO_ADS_COMMENTS);
      }
      const score = generateNormalScore(gameState.adFrequency);
      return getCommentForScore(score, AD_FREQUENCY_COMMENTS);
    }
    case "personalization": {
      const score = generateNormalScore(gameState.adPersonalization);
      return getCommentForScore(score, PERSONALIZATION_COMMENTS);
    }
    case "algorithm": {
      return ALGORITHM_COMMENTS.getComment(
        gameState.algorithmLevel,
        gameState.adFrequency
      );
    }
    case "engagement": {
      return ENGAGEMENT_COMMENTS.getComment(
        gameState.algorithmLevel,
        gameState.adFrequency
      );
    }
    default: {
      return;
    }
  }
}

// Export the main function
